/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ArrowPreviousIcon = /*#__PURE__*/ createSvgIcon(
  'ArrowPreviousIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6.875 10.75l3.671 3.671c.15.15.225.325.225.527a.762.762 0 01-.23.541.746.746 0 01-.53.22.722.722 0 01-.528-.226l-4.954-4.96a.724.724 0 01-.216-.526c0-.1.017-.194.052-.282a.69.69 0 01.156-.236l4.958-4.958a.733.733 0 011.063 0 .71.71 0 01.229.527c0 .204-.075.381-.226.532l-3.67 3.67h8.375c.213 0 .39.071.535.214a.72.72 0 01.215.532c0 .21-.072.39-.215.535a.72.72 0 01-.535.219H6.875z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default ArrowPreviousIcon;
